export const componentGroupHasVariants = ({ theSlotsAllowedComponentGroups, componentGroups, variants }) => {
  const items = theSlotsAllowedComponentGroups
    .flatMap((id) =>
      // Get the list of ids from the component group.
      componentGroups.get(id).productVariantIds
      // Map over the ids and get the variant.
      .map((id) => variants.get(id)))
      // Filter out any empty arrays.
      .filter((item) => item);

  return items.length > 0;
};